import ManageNewsletterComponent from 'components/opportunities/newsletter/ManageNewsletterComponent';
import { useTitle } from 'utils/router';

export default function ManageNewsletter() {
  useTitle('Newsletter Management');
  return <ManageNewsletterComponent />;
}
